import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { GQLRootQueryToPostConnectionWhereArgs } from '../generated/graphql'
import { useBreakpoint } from '../hooks/use-breakpoint'
import { BlogArticleList } from './blog-article-list'
import { Section } from './section'
import { SectionTitle } from './section-title'

const BlogArticleListContainer = styled.div`
  width: 80rem;
  max-width: 100vw;
  padding: 4rem 2rem;
  box-sizing: border-box;
`

type BlogSectionProps = {
  count?: number
  showMobile?: boolean
  where?: GQLRootQueryToPostConnectionWhereArgs
  where2?: GQLRootQueryToPostConnectionWhereArgs
}
export const BlogSection: FunctionComponent<BlogSectionProps> = ({count, showMobile, where, where2}) => {
  const isMobile = useBreakpoint('40rem')
  return <Section>
    <SectionTitle>ブログ</SectionTitle>
    <BlogArticleListContainer>
      <BlogArticleList count={count ?? (isMobile ? 3 : 4)} where={where} where2={where2}/>
    </BlogArticleListContainer>
  </Section>
}